
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/your-target-IELTS-score",
      function () {
        return require("private-next-pages/elearning/your-target-IELTS-score.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/your-target-IELTS-score"])
      });
    }
  